import axios from '../../axios';
import { useQuery } from '@tanstack/react-query';
import type { TError } from '@onesource/schemas';
import { ENTITY } from '../entity';
import type { TFormSubmission } from './start-submission';

export const useGetUserFormSubmissionsQueryKey = (formId: string) => [ENTITY, 'form', formId, 'submissions'];

/**
 * Hook to fetch the current user's submissions for a form
 *
 * @param formId - Form ID (UUID)
 */
export const useGetUserFormSubmissions = (formId: string) => {
  return useQuery<TFormSubmission[], TError>({
    queryKey: useGetUserFormSubmissionsQueryKey(formId),
    queryFn: async () => {
      const res = await axios.get<TFormSubmission[]>(`/community-hub/forms/${formId}/submissions`);
      return res.data;
    },
    enabled: !!formId,
  });
};
